
const prefix = (import.meta.env.VITE_API_PREFIX ?? "").replace(/\/$/, "")

/**
 * For a passed endpoint generate a map that follows:
 * namespace >> method >> [url, body]
 */

const generateEndpoints = (namespace, { identifierKey = "id" } = {}) => {
  return {
    get: {
      get: (id) => [`${namespace}/${id}`],
      getAll: () => [`${namespace}`],
    },
    post: {
      create: (item) => [`${namespace}`, item],
      search: (params) => [`${namespace}/search`, params],
    },
    put: {
      update: (item) => [`${namespace}/${item[identifierKey]}`],
    },
    delete: {
      delete: (item) => [`${namespace}/${item[identifierKey]}`],
    },
  };
};

export { generateEndpoints, prefix };
